<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="500">
      <template v-slot:activator="{ on }">
        <v-list-item v-on="on">
          <v-list-item-title>{{ $t("qrCodeDialog.inviteLink") }}</v-list-item-title>
        </v-list-item>
      </template>

      <v-card>
        <v-card-title class="headline primary white--text" primary-title
          >{{ $t("qrCodeDialog.cardTitle") }}
        </v-card-title>
        <img id="logo" style="display: none" width="100px" height="100px" :src="imageUrl" />

        <v-card-text class="mt-2">
          <h2>{{ $t("qrCodeDialog.cardText") }}</h2>
          <div class="d-flex flex-row justify-space-between">
            <v-select
              class="mr-2"
              style="max-width: 200px"
              v-model="openInApp"
              :items="linkOptions"
              item-text="name"
              item-value="val"
              hint="Open Preferences"
              persistent-hint
            ></v-select>
            <v-select
              class="ml-2"
              style="max-width: 200px"
              v-model="subgroup"
              :items="allSubgroups"
              item-text="name"
              item-value="id"
              label="No sobgroup"
              hint="Invite to subgroup"
              persistent-hint
              single-line
            ></v-select>
          </div>
          <div class="d-flex mt-4">
            <!-- <v-text-field link>{{inviteLink}}</v-chip> -->
            <v-text-field
              ref="textToCopy"
              hide-details
              :value="inviteLink"
              dense
              filled
              outlined
              readonly
            ></v-text-field>
            <v-btn class="ml-2 primary" @click="doCopy">
              <div v-if="linkCopiedSnackbar">Copied! <v-icon color="white">mdi-check</v-icon></div>
              <div v-else>{{ $t("qrCodeDialog.copy") }}</div>
            </v-btn>
          </div>
          <div class="mx-auto text-center">
            <canvas id="canvas" crossorigin="anonymous"></canvas>
          </div>
          <div class="d-flex flex-row-reverse">
            <v-btn @click="onQRButton" class="primary align-right"
              >{{
                hasQRCodeLoaded
                  ? $t("qrCodeDialog.hasQRCodeLoadedT")
                  : $t("qrCodeDialog.hasQRCodeLoadedF")
              }}
            </v-btn>
          </div>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="dialog = false">{{ $t("common.close") }}</v-btn>
        </v-card-actions>
      </v-card>
      <v-snackbar v-model="linkUpdatedSnackbar" timeout="1000">
        Link updated

        <template v-slot:action="{ attrs }">
          <v-btn color="primary" text v-bind="attrs" @click="linkUpdatedSnackbar = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
      <v-snackbar v-model="linkCopiedSnackbar" timeout="1000">
        Link Copied

        <template v-slot:action="{ attrs }">
          <v-btn color="primary" text v-bind="attrs" @click="linkCopiedSnackbar = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </v-dialog>
  </div>
</template>

<script>
import QRCode from "qrcode";
import storage from "@/firebase/storage";

export default {
  data() {
    return {
      dialog: false,
      imageUrl: null,
      hasQRCodeLoaded: false,
      subgroup: null,
      openInApp: true,
      linkOptions: [
        {
          val: true,
          name: "Open Mobile App",
        },
        {
          val: false,
          name: "Open Web App",
        },
      ],
      linkUpdatedSnackbar: false,
      linkCopiedSnackbar: false,
    };
  },
  computed: {
    allSubgroups() {
      const subgroupsIds = Object.keys(this.$store.state.trip.subgroups);
      const subgroupsAll = this.$store.state.trip.subgroups;

      const mapped = subgroupsIds.map((id) => subgroupsAll[id]);
      mapped.unshift({ id: null, name: "None" });
      return mapped;
    },
    inviteLink() {
      const { trip } = this.$store.state.trip;
      const companyId = trip.company;
      let lang = "";
      let subgroup = "";
      let companyStr = "";
      const company = this.$store.getters.tripCompany;
      if (company) {
        lang = company.language ? `&lang=${company.language}` : "";
        companyStr = `&company=${companyId}`;
      }
      if (this.subgroup) {
        subgroup = `&group=${this.subgroup}`;
      }
      const isDev = window.location.origin.includes("dev");
      const domain = isDev ? "dev" : "app";
      const linkDomain = isDev ? "dev.link" : "link";

      return `https://${this.openInApp ? linkDomain : domain}.triploop.com/join-trip?tripId=${
        trip.id
      }${companyStr}${lang}${subgroup}`;
    },
  },
  watch: {
    inviteLink() {
      this.linkUpdatedSnackbar = true;
      this.hasQRCodeLoaded = false;
      this.generateQR();
    },
  },
  methods: {
    doCopy() {
      const textToCopy = this.$refs.textToCopy.$el.querySelector("input");
      textToCopy.select();
      document.execCommand("copy");
      this.linkCopiedSnackbar = true;
    },
    onQRButton() {
      if (this.hasQRCodeLoaded) {
        this.downloadImage();
      } else {
        this.generateQR();
      }
    },
    downloadImage() {
      const canvas = document.getElementById("canvas");
      const imgUrl = canvas.toDataURL("image/jpeg");

      const downloadLink = document.createElement("a");
      downloadLink.href = imgUrl;
      downloadLink.download = `${this.$store.state.trip.trip.name}.jpeg`;

      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    },
    addImage() {
      console.log("addImage!", this.hasQRCodeLoaded);
      const canvas = document.getElementById("canvas");
      if (canvas === null) return;
      const ctx = canvas.getContext("2d");

      const img = new Image();
      img.onload = () => {
        console.log("image completed, drawing");
        setTimeout(() => {
          ctx.beginPath();
          ctx.arc(canvas.width / 2, canvas.height / 2, canvas.width / 8, 0, 2 * Math.PI);
          ctx.fillStyle = "white";
          ctx.fill();

          ctx.drawImage(
            img,
            canvas.width / 2 - canvas.width / 10,
            canvas.height / 2 - canvas.height / 10,
            canvas.width / 5,
            canvas.width / 5,
          );
        }, 500);
      };
      if (this.imageUrl && this.hasQRCodeLoaded) {
        img.crossOrigin = "anonymous";
        img.src = this.imageUrl;
      } else {
        console.log("image not completed,nott drawing");
      }

      // let img = document.getElementById("logo");
      console.log(img);
    },
    async generateQR() {
      this.hasQRCodeLoaded = false;
      const { trip } = this.$store.state.trip;

      const { companies } = this.$store.state;
      if (trip.company && companies[trip.company] && companies[trip.company].logo) {
        const { logo } = companies[trip.company];
        console.log("theres a company");
        this.imageUrl = await storage.getDownloadURL(logo);
      }
      const canvas = document.getElementById("canvas");

      QRCode.toCanvas(
        canvas,
        this.inviteLink,
        {
          errorCorrectionLevel: "Medium",
          margin: this.subgroup ? 12 : 6,
          width: 300,
        },
        (error) => {
          if (error) console.error(error);
          const ctx = canvas.getContext("2d");
          ctx.textAlign = "center";
          ctx.font = "20px Arial";
          ctx.fillText(trip.name, canvas.width / 2, 20);
          if (this.subgroup) {
            const { name } = this.allSubgroups.filter((s) => s.id === this.subgroup)[0];
            ctx.font = "16px Arial";
            ctx.fillText(name, canvas.width / 2, 40);
          }
          this.hasQRCodeLoaded = true;
          console.log("finished loading image");
          this.addImage(ctx);
        },
      );
    },
  },
};
</script>
